<template>
  <div>
    <div ref="scrollViewRef" v-show="answer.content !== ''" class="chat-text f14 markdown-body"
      v-html="answer.markdownContent === '' ? answer.content : answer.markdownContent">
    </div>
  </div>
</template>

<script>
import { getStorage } from '@/utils/storage'
import { fetchEventSource } from '@microsoft/fetch-event-source'
// import { newConversation } from '@/api/ai/bot'

import 'github-markdown-css'
import hljs from 'highlight.js'
import MarkdownIt from 'markdown-it'
import MarkdownItAnchor from 'markdown-it-anchor'
export default {
  props: {
    apiUrl: {
      type: String,
      reuqired: true
    },
    filePath: [String],
    stationIds: [String],
    botId: [String],
    workflowId: [String]
  },
  data () {
    return {
      chatFlowApi: '',
      markdown: null,
      conversationId: '',
      controller: null,
      answer: {
        status: 'loading',
        content: '',
        markdownContent: ''
      }
    }
  },
  mounted () {
    // 初始化markdown-it
    this.markdown = new MarkdownIt()
    this.markdown.set({
      html: true, // 启用HTML标签
      breaks: true, // 转换换行符为<br>
      linkify: true, // 自动转换URL为链接
      typographer: true, // 启用语言中性的替换
      highlight: function (str, lang) {
        let highlighted = str // 默认为原始字符串
        if (lang && hljs.getLanguage(lang)) {
          try {
            highlighted = hljs.highlight(str, {
              language: lang,
              ignoreIllegals: true
            }).value
          } catch (__) {
            highlighted = this.markdown.utils.escapeHtml(str) // 确保对于高亮失败的情况进行处理
          }
        } else {
          highlighted = this.markdown.utils.escapeHtml(str)
        }

        return `<pre class="hljs">${highlighted}<code></code></pre>`
      }
    }).use(MarkdownItAnchor)

    this.markdown.renderer.rules.link_open = function (tokens, idx, options, env, self) {
      const aIndex = tokens[idx].attrIndex('target')
      if (aIndex !== -1) {
        // 知果已经有 target 属性，则不做处理
        return self.renderToken(tokens, idx, options)
      }
      // 涨加 target=" blank”属性
      tokens[idx].attrPush(['target', ' blank'])
      tokens[idx].attrPush(['rel', 'noopener noreferrer'])
      // 渲染标签
      return self.renderToken(tokens, idx, options)
    }
  },
  methods: {
    async onStart () {
      const that = this
      if (that.url === '') {
        return
      }

      if (that.controller) {
        // 中止上次连接
        that.controller.abort()
      }

      that.chatFlowApi = `${process.env.VUE_APP_API_URL_V2}${that.apiUrl}`
      that.startAnswer = false
      that.answer.status = 'loading'
      that.answer.content = '正在分析处理中...'
      that.answer.markdownContent = ''

      // const { data } = await newConversation({ botId: this.botId })
      // that.conversationId = data || ''

      that.controller = new AbortController()
      const signal = that.controller.signal

      let answerText = ''
      // 请求接口
      const postData = {
        stationIds: that.stationIds && that.stationIds !== '' ? that.stationIds : undefined,
        imageUrl: that.filePath && that.filePath !== '' ? that.filePath + '?x-oss-process=image/resize,w_1500' : undefined
      }
      fetchEventSource(that.chatFlowApi, {
        method: 'POST',
        headers: {
          'ooh-auth': getStorage('ooh-token')
          // 'Content-Type': 'application/json'
        },
        body: JSON.stringify(postData),
        signal,
        openWhenHidden: true,
        async onopen (response) { // 建立连接的回调
          answerText = response.ok ? '' : '网络连接失败'
        },
        onmessage (e) {
          if (e.event === '') {
            const d = JSON.parse(e.data)
            if (d.event && d.event === 'conversation.message.delta') {
              if (d.message.type && d.message.type === 'answer') {
                answerText += d.message.content
                that.answer.status = 'loading'
                that.answer.content = answerText
                that.answer.markdownContent = that.markdown.render(answerText)
              }
            } else if (d.event === 'conversation.message.completed') {
              if (d.message.type && d.message.type === 'answer') {
                answerText += '<p></p>'
              }
            }
          } else {
            that.controller.abort()
          }
          that.scrollToBottom()
        },
        onclose () {
          that.answer.status = 'finish'
          that.controller.abort() // 关闭连接
        },
        onerror (e) {
          that.answer.status = 'finish'
          that.answer.content = '分析失败'
          throw e
        }
      })
    },
    scrollToBottom () {
      this.$nextTick(() => {
        const scrollElem = this.$refs.scrollViewRef
        scrollElem.scrollTo({
          top: scrollElem.scrollHeight,
          behavior: 'smooth'
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
.chat-text {
  margin: 12px 0 24px;
  background-color: #fafbfc;
  // padding: 20px;
  border-radius: 6px;
  // max-width: 90%;
  line-height: 1.5;
}

.markdown-body {
  box-sizing: border-box;
  width: 100%;
  max-height: 480px;
  overflow-y: auto;
  margin: 0 auto;
  padding: 10px;
  font-size: 14px;
  color: #333
}
</style>
